import { type Unsubscriber } from 'svelte/store';
import dayjs from '$lib/dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import i18nStore, {
	initI18n,
	changeLanguage,
} from '$lib/i18n';
import marketLocale from '$lib/stores/market';

function init(): Unsubscriber {
	dayjs.extend(relativeTime);
	dayjs.extend(isToday);
	dayjs.extend(isYesterday);
	dayjs.extend(localizedFormat);

	initI18n();

	const unsubscribeMarket = marketLocale.subscribe((locale) => {
		changeLanguage(locale);
	});

	const unsubscribeI18n = i18nStore.subscribe((i18n) => {
		for (const lang of i18n.languages) {
			try {
				dayjs.locale(lang);
				break; // Stop after successfully loading the first available locale
			} catch (error) {
				console.error(`Could not load lang '${lang}':`, error);
			}
		}
	});

	return () => {
		unsubscribeMarket();
		unsubscribeI18n();
	};
}

export default init;
